import { Input, Select } from "antd";
import React, { useState } from "react";

import "./stylesPromoNotificationForm.css";
import PromotionalCard from "./PromotionalCard";

const promotions = [
  {
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/ed13c5bcf92ec6798a04dba635016b15ca6bda5a?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    actionIcon:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/c1686b947bc60b336cc78aa8a60db42609a5efc0?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    title: "Purchase Match",
    description:
      "Create a deposit bonus campaign to give players extra funds based",
    backgroundColor: "#fd6f2780",
  },
  {
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/73956f454bce9b344eeba328d77304a7627a248f?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    actionIcon:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/2ab38cc9be5e7ebfd865cb7595b7e2d2a129ce46?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    title: "Free Bets",
    description: "Create a one-time free bet promotion to engage new players",
    backgroundColor: "#757582",
  },
  {
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/f9ce1b8f4afd1b4e24551e2e1a18eccb4d8cbec9?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    actionIcon:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/04e29605c9981b14bcb381c8f6cb1699eab4156e?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    title: "Profit Boost",
    description:
      "Create an odds boost for parlays with a specific number of legs",
    backgroundColor: "#757582",
  },
];

function PromoNotificationForm({ setActivePromoVariant }) {
  const [selectedPromo, setSelectedPromo] = useState(promotions[0].title);

  return (
    <div className="formSection promo-notification-form">
      <div className="email-notification-header">
        <h2>Promo Variants</h2>
        <button>Save As Template</button>
      </div>
      <div className="promotionsGrid">
        {promotions.map((promo, index) => (
          <PromotionalCard
            key={index}
            icon={promo.icon}
            title={promo.title}
            description={promo.description}
            isActive={selectedPromo === promo.title}
            setSelectedPromo={setSelectedPromo}
            setActivePromoVariant={setActivePromoVariant}
          />
        ))}
      </div>
      <div className="promo-notification-content">
        <div className="transaction-info">
          <h3>Deposit Match Percentage</h3>
          <div className="transaction-info-item">
            <span>Max Deposit Match Amount</span>
            <Input />
          </div>
        </div>
        <div className="transaction-info">
          <h3>Bonus Time Frames</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>Allocated Time To Make a Purchase</span>
              <Input placeholder="ex: 1" />
            </div>
            <div className="transaction-info-item">
              <span>Hours or Days</span>
              <Input placeholder="ex: day" />
            </div>
          </div>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>Allocated Time To Use The Free Bet</span>
              <Input placeholder="ex: 1" />
            </div>
            <div className="transaction-info-item">
              <span>Hours or Days</span>
              <Input placeholder="ex: day" />
            </div>
          </div>
        </div>
        <div className="transaction-info">
          <h3>Bet Types</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>Eligible bet type</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "Single", label: "Single" },
                  { value: "Multiple", label: "Multiple" },
                ]}
              />
            </div>
            <div className="transaction-info-item">
              <span>Prematch/Live</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "Prematch", label: "Prematch" },
                  { value: "Live", label: "Live" },
                ]}
              />
            </div>
          </div>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>Min. legs</span>
              <Input placeholder="0" />
            </div>
            <div className="transaction-info-item">
              <span>Max. legs</span>
              <Input placeholder="0" />
            </div>
          </div>
        </div>
        <div className="transaction-info">
          <h3>Sportsbook Requirements</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>Sports</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "Soccer", label: "Soccer" },
                  { value: "Tennis", label: "Tennis" },
                  { value: "Basketball", label: "Basketball" },
                ]}
              />
            </div>
            <div className="transaction-info-item">
              <span>Leagues</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "NBA", label: "NBA" },
                  { value: "NHL", label: "NHL" },
                  { value: "NFL", label: "NFL" },
                ]}
              />
            </div>
          </div>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>Teams</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "Team A", label: "Team A" },
                  { value: "Team B", label: "Team B" },
                  { value: "Team C", label: "Team C" },
                ]}
              />
            </div>
            <div className="transaction-info-item">
              <span>Events</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "Event A", label: "Event A" },
                  { value: "Event B", label: "Event B" },
                  { value: "Event C", label: "Event C" },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="transaction-info">
          <h3>Odds Limit</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>Min. odds</span>
              <Input placeholder="0" />
            </div>
            <div className="transaction-info-item">
              <span>Max. odds</span>
              <Input placeholder="0" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromoNotificationForm;
